var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8388 10.0606C10.8899 10.1117 10.9305 10.1724 10.9581 10.2391C10.9858 10.3059 11 10.3775 11 10.4497C11 10.522 10.9858 10.5935 10.9581 10.6603C10.9305 10.7271 10.8899 10.7877 10.8388 10.8388C10.7877 10.8899 10.7271 10.9305 10.6603 10.9581C10.5935 10.9858 10.522 11 10.4497 11C10.3775 11 10.3059 10.9858 10.2391 10.9581C10.1724 10.9305 10.1117 10.8899 10.0606 10.8388L5.5 6.27752L0.939378 10.8388C0.836182 10.942 0.696217 11 0.550275 11C0.404333 11 0.264368 10.942 0.161172 10.8388C0.0579752 10.7356 2.87687e-09 10.5957 0 10.4497C-2.87687e-09 10.3038 0.0579752 10.1638 0.161172 10.0606L4.72248 5.5L0.161172 0.939378C0.0579752 0.836182 -1.08735e-09 0.696217 0 0.550275C1.08735e-09 0.404333 0.0579752 0.264368 0.161172 0.161172C0.264368 0.0579752 0.404333 1.08735e-09 0.550275 0C0.696217 -1.08735e-09 0.836182 0.0579752 0.939378 0.161172L5.5 4.72248L10.0606 0.161172C10.1638 0.0579752 10.3038 -2.87687e-09 10.4497 0C10.5957 2.87687e-09 10.7356 0.0579752 10.8388 0.161172C10.942 0.264368 11 0.404333 11 0.550275C11 0.696217 10.942 0.836182 10.8388 0.939378L6.27752 5.5L10.8388 10.0606Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e60bb0dd85f0bcb9ef4ea3560ac131cd.svg";
export { ForwardRef as ReactComponent };